export default __webpack_public_path__ + "static/media/icon-Hub-Pipeline.9385febe.svg";